export const statusList = [
    { label: '판매', name: 'bookForSale' },
    { label: '대여', name: 'bookForRent' },
    // { label: '대여 중', name: 'bookRenting' },
    // { label: '대여 요청', name: 'bookRentRequest' },
    { label: '나눔', name: 'bookForShare' }
];

export const categoryList = [
    { label: '소설', name: 'NOVEL', icon: require('../assets/icons/novel.png') },
    { label: '인문', name: 'HUMANITIES', icon: require('../assets/icons/literature.png') },
    { label: '컴퓨터/IT', name: 'IT', icon: require('../assets/icons/computer.png') },
    { label: '외국어', name: 'LANGUAGE', icon: require('../assets/icons/language.png') },
    { label: '역사/문화', name: 'CULTURE', icon: require('../assets/icons/history.png') },
    { label: '과학', name: 'SCIENCE', icon: require('../assets/icons/science.png') },
    { label: '잡지', name: 'MAGAZINES', icon: require('../assets/icons/magazine.png') },
    { label: '어린이', name: 'CHILDREN', icon: require('../assets/icons/children.png') },
    { label: '자기개발', name: 'DEVELOPMENT', icon: require('../assets/icons/headphone.png') },
    { label: '여행', name: 'TRAVEL', icon: require('../assets/icons/travel.jpg') },
    { label: '요리', name: 'COOKING', icon: require('../assets/icons/cooking.png') },
    { label: '기타', name: 'OTHERS', icon: require('../assets/icons/star.png') }
];
export const bestSellersCategories = [
    { label: '소설', name: 'NOVEL' },
    { label: '인문', name: 'HUMANITIES' },
    { label: '컴퓨터/IT', name: 'IT' },
    { label: '외국어', name: 'LANGUAGE' },
    { label: '역사/문화', name: 'CULTURE' },
    { label: '과학', name: 'SCIENCE' },
    { label: '기타', name: 'OTHERS' }
];

export const bookStateList = [
    { label: '판매 중', name: 'SALE' },
    { label: '판매 완료', name: 'SOLD' },
    { label: '대여 완료', name: 'RENT' },
    { label: '대여 가능', name: 'AVAILABLE' },
    { label: '나눔', name: 'SHARED' }
];
